import React, { useEffect, useState } from "react"
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from "react-redux";
import {
  Card,
  CardBody,
  Col,
  Row,
  Label,
  Input,
  Button,
  CardImg
} from "reactstrap"
import { getStoreDetailsFromCache } from "helpers/cache_helper"
import { editItemDirect as onEditItemDirect } from "helpers/backend_helper"
import Loader from "components/Common/Loader"
import SweetAlert from "react-bootstrap-sweetalert"
import {postImages} from "helpers/backend_helper"
import StoresDropdown from "components/CommonForBoth/TopbarDropdown/StoresDropdown"

const StoreDetails = props => {

  const dispatch = useDispatch()

  useEffect(() => {
    fetchStoreDetails(true)
  }, []);

  const [storeDetails, setStoreDetails] = useState({})
  const [showLoading, setShowLoading] = useState(false)
  const [editFirstRow, setEditFirstRow] = useState(false)
  const [editSecondRow, setEditSecondRow] = useState(false)
  const [editThirdRow, setEditThirdRow] = useState(false)
  
  const [showErrorPopUp, setShowErrorPopUp] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [newLogo, setNewLogo] = useState()

  function fetchStoreDetails(fromCache){
    getStoreDetailsFromCache(fromCache).then(resp =>{
      setStoreDetails(resp)
    })
  }

  const [validation, setValidation] = useState({
    storename: null
  })

  function validateFormSubmit(){
    let formValid = true;
    const modifiedV = { ...validation }
    mandatoryFields.forEach(eachItem =>{
      if(storeDetails[eachItem] && storeDetails[eachItem].trim() != ""){
        modifiedV[eachItem] = true
      }
      else{
        modifiedV[eachItem] = false
        formValid = false
      }
    })
    setValidation(modifiedV)

    return formValid
  }

  async function submitDetails(storeDetails){
    setShowLoading(true)
    const response = await onEditItemDirect(storeDetails, 'StoreDetails')
    if(response && response.status === 'failure'){
      setShowErrorPopUp(true)
      setErrorMessage(response.errorResponse)
    }
    else if(response && response.status === 'success'){
      fetchStoreDetails(false)
      setEditSecondRow(false)
      setEditFirstRow(false)
      setEditThirdRow(false)
    }
    setShowLoading(false)
  }

  async function updateStoreDetails(){
    let isFormValid = validateFormSubmit()
    if(isFormValid){
      submitDetails(storeDetails)
    }
  }
  const mandatoryFields = ['storename']
  const onChangeValidation = (fieldName, value) => {
    if(mandatoryFields.includes(fieldName)){
      const modifiedV = { ...validation }
      if (value !== "") {
        modifiedV[fieldName] = true
      } else {
        modifiedV[fieldName] = false
      }
      setValidation(modifiedV)
    }
  }

  const uploadImageCallBack =  async (file) => {
    setShowLoading(true)
    const data = new FormData();
    /*
    files.map((file, index) => {
      data.append(`files`, file);
    });*/
    data.append(`files`, file);
    const response =  await postImages(data)
    if(response.status == 'success'){
      setStoreDetails({
        ...storeDetails,
        storelogo : response.url
      })
      const localStoreDetails = {...storeDetails}
      localStoreDetails["storelogo"] = response.url
      submitDetails(localStoreDetails)
      //return response.url
    }
    else{
      //return ""
    }
  }

  function uploadLogo(){
    if(newLogo && newLogo != ''){
      uploadImageCallBack(newLogo)
    }
  }
 
  return (
    <React.Fragment>
      <Loader showLoader={showLoading} />
      <Row>
        <Col>
          <Card>
            <CardBody>
            {!editFirstRow && <>
              <Row>
                <Col lg="6">
                </Col>
                <Col lg="1">
                  <Button
                    color="secondary"
                    className="btn btn-secondary mt-0"
                    onClick={() => {
                      setEditFirstRow(true)
                    }}
                    >
                      Edit
                  </Button> 
                </Col>
              </Row>
              <Row>
                <Col lg="6" className="font-size-16">
                  {storeDetails?.storename}
                </Col>
              </Row>
              <Row>
                <Col lg="6">
                  {storeDetails?.storeaddress}
                </Col>
              </Row>
              <Row>
                <Col lg="6">
                  {storeDetails?.storecity}{" - "}{storeDetails?.storepostalcode}{", "}{storeDetails?.storestate}{", "}{storeDetails?.storecountry}
                </Col>
              </Row>
              <Row>
                <Col lg="6">
                  {"Mob: "}{storeDetails?.storemobile}{", Phone: "}{storeDetails?.storephone}
                </Col>
              </Row>
              <Row>
                <Col lg="6">
                  {"Email: "}{storeDetails?.storeemail}
                </Col>
              </Row>
              <StoresDropdown/>
              
              </>
              }
              {editFirstRow && <>
              <Row>
                <Col lg="6">
                  <div className="mb-3">
                    <Label for="storename">
                      Store Name *
                    </Label>
                    <Input
                      type="text"
                      className="form-control"
                      id="storename"
                      maxLength="200"
                      value={storeDetails?.storename || ''}
                      onChange={e => {
                        setStoreDetails({
                          ...storeDetails,
                          storename : e.target.value
                        })
                        onChangeValidation("storename", e.target.value.trim())
                      }}
                    />
                    {(validation["storename"] === false) &&
                      <div className="custom-error">
                        Please enter a Valid Name
                      </div>
                    }
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg="4">
                  <div className="mb-3">
                    <Label for="storeaddress">
                      Store Address
                    </Label>
                    <Input
                      type="text"
                      className="form-control"
                      id="storeaddress"
                      maxLength="300"
                      value={storeDetails?.storeaddress || ''}
                      onChange={e => {
                        setStoreDetails({
                          ...storeDetails,
                          storeaddress : e.target.value
                        })
                      }}
                    />
                  </div>
                </Col>
                <Col lg="2">
                  <div className="mb-3">
                    <Label for="storepostalcode">
                      Postal Code
                    </Label>
                    <Input
                      type="text"
                      className="form-control"
                      id="storepostalcode"
                      maxLength="50"
                      value={storeDetails?.storepostalcode || ''}
                      onChange={e => {
                        setStoreDetails({
                          ...storeDetails,
                          storepostalcode : e.target.value
                        })
                      }}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg="2">
                  <div className="mb-3">
                    <Label for="storecity">
                      City
                    </Label>
                    <Input
                      type="text"
                      className="form-control"
                      id="storecity"
                      maxLength="50"
                      value={storeDetails?.storecity || ''}
                      onChange={e => {
                        setStoreDetails({
                          ...storeDetails,
                          storecity : e.target.value
                        })
                      }}
                    />
                  </div>
                </Col>
                <Col lg="2">
                  <div className="mb-3">
                    <Label for="storestate">
                      State
                    </Label>
                    <Input
                      type="text"
                      className="form-control"
                      id="storestate"
                      maxLength="50"
                      value={storeDetails?.storestate || ''}
                      onChange={e => {
                        setStoreDetails({
                          ...storeDetails,
                          storestate : e.target.value
                        })
                      }}
                    />
                  </div>
                </Col>
                <Col lg="2">
                  <div className="mb-3">
                    <Label for="storecountry">
                      Country
                    </Label>
                    <Input
                      type="text"
                      className="form-control"
                      id="storecountry"
                      maxLength="50"
                      value={storeDetails?.storecountry || ''}
                      onChange={e => {
                        setStoreDetails({
                          ...storeDetails,
                          storecountry : e.target.value
                        })
                      }}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg="2">
                  <div className="mb-3">
                    <Label for="storemobile">
                      Mobile
                    </Label>
                    <Input
                      type="text"
                      className="form-control"
                      id="storemobile"
                      maxLength="10"
                      value={storeDetails?.storemobile || ''}
                      onChange={e => {
                        setStoreDetails({
                          ...storeDetails,
                          storemobile : e.target.value
                        })
                      }}
                    />
                  </div>
                </Col>
                <Col lg="2">
                  <div className="mb-3">
                    <Label for="storephone">
                      Phone
                    </Label>
                    <Input
                      type="text"
                      className="form-control"
                      id="storephone"
                      maxLength="15"
                      value={storeDetails?.storephone || ''}
                      onChange={e => {
                        setStoreDetails({
                          ...storeDetails,
                          storephone : e.target.value
                        })
                      }}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg="4">
                  <div className="mb-3">
                    <Label for="storeemail">
                      Email
                    </Label>
                    <Input
                      type="text"
                      className="form-control"
                      id="storeemail"
                      maxLength="200"
                      value={storeDetails?.storeemail || ''}
                      onChange={e => {
                        setStoreDetails({
                          ...storeDetails,
                          storeemail : e.target.value
                        })
                      }}
                    />
                  </div>
                </Col>
              </Row>
              <Row className="text-center">
                <Col lg="2">
                </Col>
                <Col lg="2">
                  <Button
                    color="secondary"
                    className="btn w-lg btn-secondary "
                    onClick={() => {
                      setEditFirstRow(false)
                    }}
                    >
                      Cancel
                  </Button> 
                </Col>
                <Col lg="2">
                  <Button
                    color="primary"
                    className="btn w-lg btn-primary "
                    onClick={() => {
                      updateStoreDetails()
                    }}
                    >
                      Save
                  </Button> 
                </Col>
              </Row>
              </>}
            </CardBody>
          </Card>
          <Card>
            <CardBody>
              <Row>
                <Col lg="3">
                  <div className="mb-3">
                    <Label for="storegstin">
                      GSTIN
                    </Label>
                    <Input
                      type="text"
                      className="form-control"
                      id="storegstin"
                      maxLength="50"
                      disabled={!editSecondRow}
                      value={storeDetails?.storegstin || ''}
                      onChange={e => {
                        setStoreDetails({
                          ...storeDetails,
                          storegstin : e.target.value
                        })
                      }}
                    />
                  </div>
                </Col>
                <Col lg="3">
                  <div className="mb-3">
                    <Label for="storepan">
                      PAN
                    </Label>
                    <Input
                      type="text"
                      className="form-control"
                      id="storepan"
                      disabled={!editSecondRow}
                      maxLength="50"
                      value={storeDetails?.storepan || ''}
                      onChange={e => {
                        setStoreDetails({
                          ...storeDetails,
                          storepan : e.target.value
                        })
                      }}
                    />
                  </div>
                </Col>
                {!editSecondRow && <Col lg="1">
                  <Button
                    color="secondary"
                    className="btn btn-secondary mt-4"
                    onClick={() => {
                      setEditSecondRow(true)
                    }}
                    >
                      Edit
                  </Button> 
                </Col>}
              </Row>
              {editSecondRow && <Row className="text-center">
                <Col lg="2">
                </Col>
                <Col lg="2">
                  <Button
                    color="secondary"
                    className="btn w-lg btn-secondary "
                    onClick={() => {
                      setEditSecondRow(false)
                    }}
                    >
                      Cancel
                  </Button> 
                </Col>
                <Col lg="2">
                  <Button
                    color="primary"
                    className="btn w-lg btn-primary "
                    onClick={() => {
                      updateStoreDetails()
                    }}
                    >
                      Save
                  </Button> 
                </Col>
              </Row>}
            </CardBody>
          </Card>
          <Card>
            <CardBody>
            {!editThirdRow && <Row>
                <Label className="form-label">Logo</Label>
                <Col md={6} className="mt-1">
                  {storeDetails?.storelogo && storeDetails?.storelogo != '' &&
                  <CardImg className="img-fluid logo-md" src={storeDetails?.storelogo} alt="logo" />}
                </Col>
                 <Col lg="1">
                  <Button
                    color="secondary"
                    className="btn btn-secondary mt-0"
                    onClick={() => {
                      setEditThirdRow(true)
                    }}
                    >
                      Edit
                  </Button> 
                </Col>
              </Row>}
              {editThirdRow && <Row>
                <Col sm={6}>
                  <div className="mt-0">
                    <div>
                      <Label className="form-label">Upload Logo - <small className="text-muted">Recommended - 120 * 120 px </small> </Label>
                      <div className="input-group">
                        <Input type="file" className="form-control" id="inputGroupFile04" aria-describedby="inputGroupFileAddon04" aria-label="Upload" 
                        onChange={e => {
                          setNewLogo(e.target.files[0])
                        }}
                        />
                        <button className="btn btn-primary" type="button" id="inputGroupFileAddon04"
                        onClick={()=> uploadLogo()}>
                          Upload
                        </button>
                        <button className="btn btn-secondary" type="button" id="inputGroupFileAddon05"
                        onClick={()=> setEditThirdRow(false)}>
                          Cancel
                        </button>
                      </div>
                    </div>

                  </div>
                </Col>
              </Row>}
            </CardBody>
          </Card>
        </Col>
      </Row>
      {showErrorPopUp ? (
        <SweetAlert
          error
          title="Failed"
          onConfirm={() => {
            setShowErrorPopUp(false)
          }}
        >
          {errorMessage}
        </SweetAlert>
      ) : null}
    </React.Fragment>
  )
}

StoreDetails.propTypes = {
}

export default StoreDetails
